import useAttachments from '@hooks/useAttachments'

import { Form, LoadingModule, SidebarNoticeBox } from '@domain-group/suit-theme'

import AttachmentListItem from '../AttachmentListItem'

interface ImageListProps {
  attachableId: number,
  attachableType: string,
}

const AttachmentList = (props: ImageListProps) => {
  const { attachableId, attachableType } = props

  const attachmentsPayload = useAttachments({
    filters: {
      attachable_id: attachableId,
      attachable_type: attachableType,
    },
  })

  const {
    filteredAttachments,
    hasFilteredAttachments,
    loading,
  } = attachmentsPayload

  return (
    <Form.Field label="Attachments" labelProps={{ marginBottom: 'none' }} marginTop="large">
      {loading && <LoadingModule loading={loading} />}

      {!loading && !hasFilteredAttachments && (
        <SidebarNoticeBox boxProps={{ marginBottom: 'none' }}>
          <SidebarNoticeBox.Title>No Attachments Present</SidebarNoticeBox.Title>
        </SidebarNoticeBox>
      )}

      {!loading && filteredAttachments.map(attachment => (
        <AttachmentListItem key={attachment.id} attachment={attachment} />
      ))}
    </Form.Field>
  )
}

export default AttachmentList
